import clipboardBuilder from '../../shared/clipboard_builder.coffee'

$ ->
  if $('.copy-account-source').length > 0
    clipboardBuilder.build '.copy-account-source',
      text: (trigger)->
        $($(trigger).data('clipboard-target')).val()
